/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { SiteAdsStats } from "./data-contracts";

/**
 * No description
 * @tags analytics, sites, internal
 * @name GetAdsInsightsForSiteById
 * @summary Get analytics insights of ads on a site.
 * @request GET:/orgs/{organizationId}/sites/{siteId}/insights/ads
 * @secure
 */

// @ts-ignore
export const getAdsInsightsForSiteById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** A time serie of the ads stats over the provided period */
    values: {
      /**
       * The start date of this interval
       * @format date-time
       */
      date: string;
      stats: SiteAdsStats;
    }[];
    account: {
      /** Email address on the Ads platform. */
      email: string;
      /** URL to configure payout. */
      url: string;
    };
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/ads",
  method: "get",
  streaming: false,
  tags: ["analytics", "sites", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};
